import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { produce } from 'immer'
import { CitiesOccupancySliceModel } from '../models/cities-occupancy-slice.model'
import { MediaFormat } from 'types/campaign'

const defaultState: CitiesOccupancySliceModel = {
  loading: false,
  selectedCityName: '',
  selectedCityData: [],
  pageNumber: 1,
  totalItemsCount: 0,
  data: [],
  filters: {
    all: {
      agglomerations: [],
      cities: [],
    },
    selected: {
      fromDate: '',
      toDate: '',
      agglomerations: [],
      cities: [],
      mediaFormats: [],
    },
  },
}

const initialState: CitiesOccupancySliceModel = produce(defaultState, draft => draft)

const citiesOccupancySlice = createSlice({
  name: 'citiesOccupancy',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setData(
      state,
      action: PayloadAction<{ data: CitiesOccupancySliceModel['data']; totalItemsCount: number }>
    ) {
      state.data = action.payload.data
      state.totalItemsCount = action.payload.totalItemsCount
    },
    setPageNumber(state, action: PayloadAction<number>) {
      state.pageNumber = action.payload
    },
    setSelectedFilterDate(
      state,
      action: PayloadAction<{ key: 'fromDate' | 'toDate'; data: string }>
    ) {
      state.filters.selected[action.payload.key] = action.payload.data
    },
    setSelectedFilterDropdown(
      state,
      action: PayloadAction<{
        key: 'agglomerations' | 'cities'
        data: string[]
      }>
    ) {
      state.filters.selected[action.payload.key] = action.payload.data
    },
    setAllFilters(state, action: PayloadAction<CitiesOccupancySliceModel['filters']['all']>) {
      state.filters.all = action.payload
    },
    setSelectedMediaFormats(state, action: PayloadAction<MediaFormat[]>) {
      state.filters.selected.mediaFormats = action.payload
    },
    setSelectedCityDetails(
      state,
      action: PayloadAction<{
        cityName: string
        data: CitiesOccupancySliceModel['selectedCityData']
      }>
    ) {
      state.selectedCityName = action.payload.cityName
      state.selectedCityData = action.payload.data
    },
    resetState() {
      return defaultState
    },
  },
})

export const citiesOccupancyActions = citiesOccupancySlice.actions

export default citiesOccupancySlice
